/**
 * Normalización de texto para corrección tolerante (huecos, transcripción,
 * flashcards escritas). Puro y determinista.
 */

export interface NormalizeOpts {
  /** Distinguir mayúsculas/minúsculas (default false). */
  caseSensitive?: boolean;
  /** Conservar acentos/diacríticos (default false: se eliminan). */
  keepDiacritics?: boolean;
  /** Conservar puntuación (default false). */
  keepPunctuation?: boolean;
}

const PUNCTUATION = /[.,;:!?¿¡"'`´()[\]{}<>/\\|@#$%^&*_+=~-]/g;

export function normalizeText(input: string, opts: NormalizeOpts = {}): string {
  let s = input.normalize("NFC").trim();
  if (!opts.caseSensitive) {
    s = s.toLowerCase();
  }
  if (!opts.keepDiacritics) {
    // Descompone y elimina marcas combinantes (á → a).
    s = s.normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  if (!opts.keepPunctuation) {
    s = s.replace(PUNCTUATION, " ");
  }
  // Colapsa espacios.
  return s.replace(/\s+/g, " ").trim();
}

/** ¿`candidate` coincide con alguna de las respuestas aceptadas (normalizadas)? */
export function matchesAny(
  candidate: string,
  accepted: readonly string[],
  opts: NormalizeOpts = {},
): boolean {
  const c = normalizeText(candidate, opts);
  if (c === "") {
    return false;
  }
  for (const a of accepted) {
    if (normalizeText(a, opts) === c) {
      return true;
    }
  }
  return false;
}
